module.exports = {"minDate":"1880-01-01"};